import styled from 'styled-components'

export const Text = styled.span`
	color: ${({ theme }) => theme.color.input.textContrast};
	font-size: 12px;
	margin-left: 5px;
	vertical-align: 5px;
`
